import { IPersonaProps } from "office-ui-fabric-react";
import * as React from "react";
import { searchTeams, searchUsers } from "../api/userInfo";
import { ConstraintType, IAvailableRoomSlot, IBookingConstraint, ResourceType } from "../types/Booking.types";
import { IRoom } from "../types/SiteLocation.types";
import { ITeam, IUserWithPhoto } from "../types/User.types";

export namespace Utils {
    export function sortRoomInfoAlphabetically(a: IRoom | IAvailableRoomSlot, b: IRoom | IAvailableRoomSlot) {
        let nameA = a.Name || "", nameB = b.Name || "";
        let numRegex = /(\d{1,3})/;
        let alphaOnlyA = nameA.replace(/\d/g, '');
        let alphaOnlyB = nameB.replace(/\d/g, '');
        let numberAmatches = numRegex.exec(nameA);
        let numberBmatches = numRegex.exec(nameB);
        let numHighOrLow = 0;
        if (numberAmatches != null && numberBmatches === null) numHighOrLow = -1;
        if (numberAmatches === null && numberBmatches !== null) numHighOrLow = 1;
        if (numberAmatches !== null && numberBmatches !== null) {
            const numA = parseFloat(numberAmatches[1]), numB = parseFloat(numberBmatches[1]);
            if (numA < numB) numHighOrLow = -1;
            if (numA > numB) numHighOrLow = 1;
        }
        if (alphaOnlyA === alphaOnlyB) return numHighOrLow;
        return nameA < nameB ? -1 : 1;
    }
    export function isValidEmail(email?: string | undefined) {
        if (!email) return true;
        // eslint-disable-next-line no-control-regex
        const regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return regex.test(email);
    }
    export function dateToLocalISO(date: Date) {
        const off    = date.getTimezoneOffset()
        const absoff = Math.abs(off)
        return (new Date(date.getTime() - off*60*1000).toISOString().substr(0,23) +
                (off > 0 ? '-' : '+') + 
                Math.floor(absoff / 60).toFixed(0).padStart(2,'0') + ':' + 
                (absoff % 60).toString().padStart(2,'0'))
    }
    export function getDefaultConstraint(resourceType: ResourceType, siteId: number | null = null, locationId: number | null = null, roomId: number | null = null) {
        return {
            Id: -1,
            SiteId: siteId,
            LocationId: locationId,
            RoomId: roomId,
            Number: 1,
            ResourceType: resourceType,
            Type: ConstraintType.Week
        } as IBookingConstraint;
    }

    export function mapToPersona(obj: any) {
        let isUser = true;
        if (!obj.hasOwnProperty('Email')) {
            isUser = false;
        }
        let imageUrl: string | undefined;

        if (isUser && obj.Photo) {
            imageUrl = `data:${obj.Photo.Type};base64,${obj.Photo.Data}`;
        }
        let data: any;
        if (isUser) data = { userId: obj.Id };
        if (!isUser) data = { teamId: obj.Id };
        return ({
            text: isUser ? obj.FullName : obj.Name,
            secondaryText: isUser ? obj.Email : '(Team)',
            imageUrl, 
            data
        } as IPersonaProps);
    }

    export function userSearch(includeTeams?: boolean) {
        return async (filter: string, selectedSuggestions?: IPersonaProps[]) => {
            const userResults = await searchUsers(filter);
            const teamResults = includeTeams ? await searchTeams(filter) : [];
            const results: (IUserWithPhoto|ITeam)[] = [...userResults, ...teamResults];

            return results.map(mapToPersona);
        }
    }
}

export default Utils;